import React from "react";
import { LANGUAGES } from "../i18n";
import { Globe } from "@phosphor-icons/react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";

export default function LanguageSwitcher({ value, onChange }) {
  return (
    <div
      className="flex items-center gap-2 border border-neutral-900 bg-white h-9 pl-2"
      data-testid="language-switcher"
    >
      <Globe size={14} weight="regular" className="text-neutral-900 shrink-0" />
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger
          className="h-9 min-w-[140px] border-0 rounded-none shadow-none px-1 pr-2 text-xs font-mono uppercase tracking-wider text-neutral-900 focus:ring-0 focus:ring-offset-0 ma-trans"
          data-testid="language-switcher-select"
          aria-label="Language"
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent
          align="end"
          className="rounded-none border border-neutral-900 shadow-none"
        >
          {LANGUAGES.map((l) => (
            <SelectItem
              key={l.code}
              value={l.code}
              className="rounded-none font-mono text-xs"
              data-testid={`language-option-${l.code}`}
            >
              {l.code.toUpperCase()} — {l.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
